// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBbD7nHQjcKKynEWCO96i0UDvEOjAfOIxY',
  authDomain: 'kankin-jk.firebaseapp.com',
  projectId: 'kankin-jk',
  storageBucket: 'kankin-jk.appspot.com',
  messagingSenderId: '1080809931680',
  appId: '1:1080809931680:web:0921bba67c1fabd4a35ac5',
  measurementId: 'G-7H1F20VC4B',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
